import Vue from 'vue'
import App from './layout/components/AppMain.vue'
import router from './router.js'
import store from './store'
//localization start
import {i18n} from './i18n.js'
import getLang from './setup-languages.js'
getLang(localStorage.getItem('lang'));
//Mask
import VueTheMask from 'vue-the-mask'
//localization end
// import CKEditor from '@ckeditor/ckeditor5-vue';
//
// Vue.use( CKEditor );

Vue.use(VueTheMask);

// import notification
import { Notification } from '@totalflow4/tfelement-ui';

//resize
import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize);


// import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css'
import '../errorHandler.js'
// import VueScrollTo from 'vue-scrollto'
import VueSlideoutPanel from 'vue2-slideout-panel'

// Vue.use(VueScrollTo);
// console.log('VueScrollTo', VueScrollTo);

// Vue.use(VueScrollTo, {
//   container: "body",
//   duration: 500,
//   easing: "ease",
//   offset: 0,
//   force: true,
//   cancelable: true,
//   onStart: false,
//   onDone: false,
//   onCancel: false,
//   x: false,
//   y: true
// })
// console.log('VueScrollTo', VueScrollTo);

Vue.use(VueSlideoutPanel);

//CHAT
// import $ from 'jquery'
// import '@progress/kendo-ui'
// import '@progress/kendo-theme-default/dist/all.css'
// import { Chat, ChatInstaller } from '@progress/kendo-chat-vue-wrapper'
// import { ApiAiClient } from 'api-ai-javascript';
//
// Vue.use(Chat)
// Vue.use(ChatInstaller)
// import Chat from 'vue-beautiful-chat'
// Vue.use(Chat)

import VueSession from 'vue-session'
Vue.use(VueSession);


import VueSocketio from 'vue-socket.io-extended';
// import io from 'socket.io-client';

import socket from './sockets'
Vue.use(VueSocketio, socket );

// Element UI
import ElementUI from '@totalflow4/tfelement-ui';
import '@totalflow4/tfelement-ui/lib/theme-chalk/index.css';
import locale from '@totalflow4/tfelement-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale } );

// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// QR Code
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

// Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faUser, faUserPlus, faEnvelope, faGlobeAmericas, faCog, faFileExcel,  faCheckSquare, faKey, faPowerOff, faUserCircle, faClock, faLock, faComments, faComment, faStickyNote, faProjectDiagram, faBell, faStream, faMapMarker, faPlay, faCheck, faPause, faSync, faPhone, faClinicMedical, faUserClock, faArrowsAltH, faFile, faSearch, faPlusCircle, faAd} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUserSecret, faUser, faUserPlus, faEnvelope, faGlobeAmericas, faCog, faFileExcel, faCheckSquare, faKey, faPowerOff, faUserCircle, faClock, faLock, faComments, faComment, faStickyNote, faProjectDiagram, faBell, faStream, faMapMarker, faPlay, faCheck, faPause, faSync, faPhone, faClinicMedical, faUserClock, faArrowsAltH, faFile, faSearch, faPlusCircle, faAd)
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Tree
import "ag-grid-enterprise"
import {LicenseManager} from "ag-grid-enterprise"
LicenseManager.setLicenseKey("spider13_MTc1MDY4Mjk4NTgyMA==9051b9722dcfb391b8e3ac37f01acd5e")

// Wizard
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

// Viewer
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

// Tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import Vidle from 'v-idle'
Vue.use(Vidle)

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

// Loading
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading, {
  loader: 'dots',
  width: 100,
  height: 100,
  color: '#409EFF',
  zIndex: 99999
});
export const loading = Vue.$loading;

export const app = new Vue({
  i18n,
  router,
  store,
  // components: {
  //   Chat
  // },
  render: h => h(App)
}).$mount('#app');

